import { IntegrationsPageHeader } from "@/pages/integrations/integrations-page-header";
import { StyledPageWrapper } from "@/pages/integrations/shared/integrations.styles";
import { IntegrationsCalendarPageContent } from "@/pages/integrations/calendar/integrations-calendar-page-content";
import { observer } from "mobx-react-lite";
import { FC, useState } from "react";
import { useTimeout } from "usehooks-ts";

type TProps = {};

/**
 * Legacy route-based calendar integrations page at `/integrations/calendar`.
 *
 * This page is kept around because the Google and Outlook OAuth callback pages
 * (`/integrations/calendar/google/callback`, `/integrations/calendar/outlook/callback`)
 * are nested under the same route prefix and still need to exist as real pages
 * to process OAuth redirects. Removing this page would require restructuring
 * those callback routes.
 *
 * The equivalent settings modal tab is `SettingsTabId.CalendarAndMeetingsPage`,
 * reachable via `?settings=calendar-and-meetings`. In the future we may migrate
 * the OAuth callback handling and retire this route entirely.
 */
export const IntegrationsCalendarPage: FC<TProps> = observer(() => {
  const [visible, setVisible] = useState(false);

  useTimeout(() => {
    setVisible(true);
  }, 100);

  return (
    <StyledPageWrapper visible={visible}>
      <IntegrationsPageHeader />
      <IntegrationsCalendarPageContent />
    </StyledPageWrapper>
  );
});
